import siteMetadata from "@/data/siteMetadata";
import { AuthorSection } from "@components/blog/AuthorSection";
import { BlogPostHero } from "@components/blog/BlogPostHero";
import Link from "@components/blog/Link";
import { BlogSEO } from "@components/blog/SEO";
import Button from "@components/library/Button";
import { ReactNode } from "react";
import { AuthorFrontMatter } from "types/AuthorFrontMatter";
import { PostFrontMatter } from "types/PostFrontMatter";
import Markdown from "markdown-to-jsx";

const twitterDiscussionUrl = (slug: string) =>
  `https://mobile.twitter.com/search?q=${encodeURIComponent(
    `${siteMetadata.siteUrl}/blog/${slug}`
  )}`;

const postDateTemplate: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

interface Props {
  frontMatter: PostFrontMatter;
  authorDetails: AuthorFrontMatter[];
  next?: { slug: string; title: string };
  prev?: { slug: string; title: string };
  children: ReactNode;
}

export default function PostLayout({
  frontMatter,
  authorDetails,
  children,
}: Props) {
  const { slug } = frontMatter;

  return (
    <>
      <BlogSEO
        url={`${siteMetadata.siteUrl}/blog/${slug}`}
        authorDetails={authorDetails}
        {...frontMatter}
      />
      <article>
        <BlogPostHero post={frontMatter} authors={authorDetails} />

        <div className="container-xl">
          <div className="relative overflow-hidden bg-white pt-48 pb-[108px] sm:pt-80">
            <div className="prose prose-blue mx-auto mt-32">{children}</div>
          </div>
          <div className="mx-auto my-40 max-w-prose">
            <Button
              href={twitterDiscussionUrl(slug)}
              rel="nofollow"
              styling="link"
            >
              Discuss on Twitter
            </Button>

            {frontMatter.hackernews && (
              <Button
                href={frontMatter.hackernews}
                rel="nofollow"
                styling="link"
              >
                Join the discussion on Hacker News
              </Button>
            )}
          </div>
        </div>

        {authorDetails.map((author) => (
          <AuthorSection key={author.name} author={author} />
        ))}

        {/* TODO: add this in with style */}
        {/* <footer className="container-xl">
          <div className="font-medium divide-gray-200 text-14-16 leading-5 dark:divide-gray-700 xl:col-start-1 xl:row-start-2 xl:divide-y">
            {(next || prev) && (
              <div className="flex justify-between py-4 xl:block xl:space-y-8 xl:py-8">
                {prev && (
                  <div>
                    <h2 className="text-12-14 uppercase tracking-wide text-gray-500 dark:text-gray-400">
                      Previous Article
                    </h2>
                    <div className="text-primary-500 hover:text-primary-600 dark:hover:text-primary-400">
                      <Link href={`/blog/${prev.slug}`}>{prev.title}</Link>
                    </div>
                  </div>
                )}
                {next && (
                  <div>
                    <h2 className="text-12-14 uppercase tracking-wide text-gray-500 dark:text-gray-400">
                      Next Article
                    </h2>
                    <div className="text-primary-500 hover:text-primary-600 dark:hover:text-primary-400">
                      <Link href={`/blog/${next.slug}`}>{next.title}</Link>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </footer> */}
      </article>
    </>
  );
}
